import { render, staticRenderFns } from "./ProjectInternalNotes.vue?vue&type=template&id=0d31d819"
import script from "./ProjectInternalNotes.vue?vue&type=script&lang=js"
export * from "./ProjectInternalNotes.vue?vue&type=script&lang=js"
import style0 from "./ProjectInternalNotes.vue?vue&type=style&index=0&id=0d31d819&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QEditor,QSpinner});
